import * as ReservationAction from './reservation.action';

export interface ReservationState {
  numberProduct: number;
  data: any;
}

const initialState: ReservationState = {
  numberProduct: 0,
  data: null
};

export function reservationReducer(
  state = initialState,
  action: ReservationAction.ReservationAction
  ) {

  switch (action.type) {
    case ReservationAction.NUMBER_PRODUCT:
      return {
        ...state,
        numberProduct: action.payload.numberProduct
      };
    case ReservationAction.CART_BEFORE_LOGIN:
      return {
        ...state,
        data: action.payload.data
      };
    default:
      return state;
  }
}
